import { render, staticRenderFns } from "./UcInvoiceTypeBadge.yaml?vue&type=template&id=4b4f367e&component"
import script from "./UcInvoiceTypeBadge.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceTypeBadge.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports